// Mekân minimumu opsiyonel (A4): boşsa "En fazla N kişi"; bilinmeyen değer uydurulmaz.
export const capacityText = (min, max, unit = ' kişi') => {
  if (max === null || max === undefined || max === '') return 'Belirtilmemiş';
  return `${min ? `${min}–` : 'En fazla '}${max}${unit}`;
};
